/*
 * PAWS & PEARLS — SIX SAILBOATS / SECRET SKY v1.0 — 27 OCTOBER 2026
 * Jeeves XXVI — independent, reversible additive layer.
 * Six approved Photography Department individual sailboat masters (lossless,
 * alpha-true WebP, trimmed transparent padding only; appearance unchanged).
 * The boats drift gently without swapping images or running sprite frames.
 *
 * Preserves V18 Muse, clouds/camera, existing sailboats painted in the sky,
 * flocks, 4 companion balloons, 7 distant balloons, Lilla, zebras, hippo,
 * roof bird, music and all page controls. Does not touch existing nodes.
 *
 * DESKTOP ONLY until the mobile scene's different framing is approved.
 * Artwork coordinates are mapped against displayed 1122x1402 background:
 * x scales with rendered sky width; y is pixels of sky width/SOURCE_W,
 * NOT % of the sky container height (roof-bird correction precedent).
 */
(function () {
  'use strict';
  var SKY_ID = 'pp-muse-secret-sky';
  var LAYER_ID = 'pp-muse-six-sailboats-v1';
  var CONFIG_ID = 'pp-muse-six-sailboats-assets-v1';
  var STYLE_ID = LAYER_ID + '-style';
  var NS = 'ppMuseSixSailboatsV1';
  var SOURCE_W = 1122, SOURCE_H = 1402;
  var VERSION = '1.0-six-static-boats-slightly-increased-drift';
  var mounted = null;

  /* Original approved six-boat visual placement study.
     x = image x; y = waterline/hull bottom in full master image pixels;
     w = visible graphic width in master px.
     Motion is ONLY a fractional increase over the original preview:
     1.35x horizontal drift, 1.20x vertical bob, 1.20x tiny roll. */
  var BOATS = [
    {i:1,x:565,y:368,w:38,ax:8.0,phase:0.3,rock:0.60,ay:1.40},
    {i:2,x:748,y:280,w:22,ax:5.5,phase:1.6,rock:0.40,ay:0.75},
    {i:3,x:1018,y:407,w:45,ax:9.0,phase:2.7,rock:0.65,ay:1.50},
    {i:4,x:660,y:458,w:59,ax:11.0,phase:3.9,rock:0.75,ay:2.00},
    {i:5,x:842,y:348,w:37,ax:7.0,phase:4.7,rock:0.50,ay:1.20},
    {i:6,x:1060,y:306,w:26,ax:5.0,phase:5.4,rock:0.45,ay:0.90}
  ];
  var TWO_PI = 2 * Math.PI;
  var MULTIPLIER_X = 1.35, MULTIPLIER_Y = 1.20, MULTIPLIER_ROLL = 1.20;

  function shouldRun() {
    if (!document.documentElement.classList.contains('pp-muse-secret-sky-page')) return false;
    if (window.matchMedia && !window.matchMedia('(min-width: 768px)').matches) return false;
    var sky = document.getElementById(SKY_ID);
    var wrapper = document.querySelector('.page-wrapper');
    return !!(sky && wrapper && wrapper.contains(sky));
  }
  function getAssets() {
    var holder = document.getElementById(CONFIG_ID);
    if (!holder) return null;
    var urls = [];
    for (var i = 1; i <= 6; i++) {
      var key = 'sailboat' + (i < 10 ? '0' : '') + i;
      var url = holder.getAttribute('data-' + key);
      if (!url || !/^(https?:\/\/|\/)/.test(url)) {
        console.warn('[P&P Sailboats] Asset URL missing: ' + key);
        return null;
      }
      urls.push(url);
    }
    return urls;
  }
  function addCSS() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      'html.pp-muse-secret-sky-page #' + SKY_ID + ' #' + LAYER_ID + '{',
      'position:absolute!important;inset:0!important;z-index:1!important;',
      'pointer-events:none!important;overflow:hidden!important;user-select:none!important;}',
      'html.pp-muse-secret-sky-page #' + LAYER_ID + ' .pp-muse-sailboat-anchor{',
      'position:absolute!important;width:0!important;height:0!important;',
      'pointer-events:none!important;contain:layout style;}',
      'html.pp-muse-secret-sky-page #' + LAYER_ID + ' .pp-muse-sailboat-art{',
      'position:absolute!important;left:0!important;bottom:0!important;',
      'height:auto!important;max-width:none!important;display:block!important;',
      'transform-origin:50% 95%!important;',
      'pointer-events:none!important;user-select:none!important;',
      '-webkit-user-drag:none!important;}',
      '@media(max-width:767px){html.pp-muse-secret-sky-page #' + LAYER_ID + '{display:none!important;}}'
    ].join('');
    document.head.appendChild(style);
  }
  function preload(urls) {
    return Promise.all(urls.map(function(url) {
      return new Promise(function(resolve, reject) {
        var img = new Image();
        img.onload = function() { resolve(true); };
        img.onerror = function() { reject(new Error('Asset failed to load: ' + url)); };
        img.src = url;
        if (img.complete && img.naturalWidth) resolve(true);
      });
    }));
  }
  function scale(inst) {
    // Tall portrait background uses background-size: 100% auto, center top.
    // Align x and y with artwork, not browser window, scrollTop, or sky height.
    return (inst.sky.getBoundingClientRect().width || inst.sky.clientWidth) / SOURCE_W;
  }
  function update(inst) {
    var s = scale(inst), t = inst.elapsed / 1000;
    if (!isFinite(s) || s <= 0) return;
    for (var k = 0; k < BOATS.length; k++) {
      var b = BOATS[k], actor = inst.actors[k];
      var px = b.x, py = b.y, deg = 0;
      if (!inst.reduced) {
        px += b.ax * MULTIPLIER_X * Math.sin(TWO_PI * t / (21 + b.i * 1.8) + b.phase);
        py += b.ay * MULTIPLIER_Y * Math.sin(TWO_PI * t / (8 + b.i) + b.phase / 1.7);
        deg = b.rock * MULTIPLIER_ROLL * Math.sin(TWO_PI * t / (12 + b.i * 1.2) + b.phase * 0.6);
      }
      actor.anchor.style.left = (px * s).toFixed(2) + 'px';
      actor.anchor.style.top = (py * s).toFixed(2) + 'px';
      actor.img.style.width = (b.w * s).toFixed(2) + 'px';
      actor.img.style.transform = 'translateX(-50%) rotate(' + deg.toFixed(3) + 'deg)';
    }
  }
  function stopFrame(inst) {
    if (inst.raf) cancelAnimationFrame(inst.raf);
    inst.raf = 0;
    inst.last = 0;
  }
  function mayAnimate(inst) {
    return !inst.ended && inst.ready && inst.visible && !inst.reduced &&
      !document.hidden && (!window.matchMedia || window.matchMedia('(min-width: 768px)').matches);
  }
  function tick(inst, now) {
    inst.raf = 0;
    if (!inst.layer.isConnected || !mayAnimate(inst)) { stopFrame(inst); return; }
    if (inst.last) inst.elapsed += Math.min(100, Math.max(0, now - inst.last));
    inst.last = now;
    update(inst);
    inst.raf = requestAnimationFrame(function(n) { tick(inst, n); });
  }
  function start(inst) {
    if (inst.raf || !mayAnimate(inst)) return;
    inst.raf = requestAnimationFrame(function(n) { tick(inst, n); });
  }
  function destroy() {
    var inst = mounted;
    if (!inst) return;
    inst.ended = true;
    stopFrame(inst);
    if (inst.io) inst.io.disconnect();
    document.removeEventListener('visibilitychange', inst.onVisibility);
    window.removeEventListener('resize', inst.onResize);
    if (inst.motionQuery) {
      if (inst.motionQuery.removeEventListener) inst.motionQuery.removeEventListener('change', inst.onMotion);
      else if (inst.motionQuery.removeListener) inst.motionQuery.removeListener(inst.onMotion);
    }
    if (inst.layer.isConnected) inst.layer.remove();
    mounted = null;
  }
  function attach() {
    if (!shouldRun()) return;
    var sky = document.getElementById(SKY_ID);
    if (mounted && mounted.sky === sky && mounted.layer.isConnected) return;
    if (mounted) destroy();
    if (document.getElementById(LAYER_ID)) return;
    var urls = getAssets();
    if (!urls) return;
    addCSS();
    var layer = document.createElement('div');
    layer.id = LAYER_ID;
    layer.setAttribute('aria-hidden', 'true');
    layer.style.visibility = 'hidden';
    var actors = [];
    for (var j=0; j<BOATS.length; j++) {
      var anchor = document.createElement('span');
      anchor.className = 'pp-muse-sailboat-anchor';
      var img = document.createElement('img');
      img.className = 'pp-muse-sailboat-art';
      img.src = urls[j];
      img.alt = '';
      img.decoding = 'async';
      img.draggable = false;
      anchor.appendChild(img);
      layer.appendChild(anchor);
      actors.push({ anchor:anchor, img:img });
    }
    sky.appendChild(layer);
    var inst = {
      sky:sky, layer:layer, actors:actors, elapsed:0, last:0,
      ready:false, visible:false, reduced:false, ended:false, raf:0,
      io:null, motionQuery:null, onVisibility:null, onResize:null, onMotion:null
    };
    mounted = inst;
    inst.motionQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    inst.reduced = !!(inst.motionQuery && inst.motionQuery.matches);
    inst.onVisibility = function() { if (document.hidden) stopFrame(inst); else start(inst); };
    inst.onResize = function() {
      if (window.matchMedia && !window.matchMedia('(min-width: 768px)').matches) stopFrame(inst);
      update(inst); start(inst);
    };
    inst.onMotion = function(e) {
      inst.reduced = !!e.matches;
      if (inst.reduced) { stopFrame(inst); inst.elapsed=0; update(inst); }
      else start(inst);
    };
    document.addEventListener('visibilitychange', inst.onVisibility);
    window.addEventListener('resize', inst.onResize, { passive:true });
    if (inst.motionQuery) {
      if (inst.motionQuery.addEventListener) inst.motionQuery.addEventListener('change', inst.onMotion);
      else if (inst.motionQuery.addListener) inst.motionQuery.addListener(inst.onMotion);
    }
    preload(urls).then(function() {
      if (inst.ended) return;
      inst.ready = true;
      update(inst);
      inst.layer.style.visibility = 'visible';
      if ('IntersectionObserver' in window) {
        inst.io = new IntersectionObserver(function(entries) {
          var e = entries[0];
          inst.visible = !!(e && e.isIntersecting);
          if (inst.visible) start(inst); else stopFrame(inst);
        }, { threshold:0.01 });
        inst.io.observe(inst.sky);
      } else { inst.visible = true; start(inst); }
    }).catch(function(err) {
      console.warn('[P&P Sailboats] One or more sailboat assets could not be loaded; nothing else altered.', err);
      destroy();
    });
  }
  function onSectionUnload(ev) {
    if (!mounted || !ev.target) return;
    if (ev.target === mounted.sky || ev.target.contains(mounted.sky)) destroy();
  }
  window[NS] = {
    version:VERSION,
    getStatus:function() {
      var inst=mounted;
      return { installed:!!(inst&&inst.layer.isConnected), ready:!!(inst&&inst.ready),
        boats:inst?inst.actors.length:0, moving:!!(inst&&mayAnimate(inst)),
        sourceArtwork:'6 approved Photography Department sailboat individual masters',
        horizontalDriftIncrease:'35% over approved concept preview',
        mobile:'not mounted below 768px, pending separate mobile framing review',
        mapping:'1122x1402 master artwork, scaled by displayed sky width',
        modifiesExistingHouseAnimations:false };
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attach, { once:true });
  else attach();
  document.addEventListener('shopify:section:load', attach);
  document.addEventListener('shopify:section:unload', onSectionUnload);
  window.addEventListener('pageshow', attach);
})();
